/** Based on VS Code Dark+ */

.prism-code-editor {
	font-family: Consolas, Monaco, "Andale Mono", "Ubuntu Mono", monospace;
	--pce-cursor: #aeafad;
	--pce-bg: #1e1e1e;
	--pce-widget-border: #444;
	--pce-widget-bg: #1e1e1e;
	--pce-widget-color: #ccc;
	--pce-widget-color-active: #fff;
	--pce-widget-color-options: #aaa;
	--pce-widget-bg-input: #262626;
	--pce-widget-bg-hover: #2e2e2e;
	--pce-widget-bg-active: #336699;
	--pce-widget-focus: #5299e0;
	--pce-search-match: #eb5e0054;
	--pce-widget-bg-error: #4d1919;
	--pce-widget-error: #cc0000;
	--pce-border-highlight: 2px solid #282828;
	--pce-selection-match: #add6ff26;
	--pce-line-number: #888;
	--pce-scrollbar: 0, 0%, 50%;
	--pce-bg-fold: #c5c5c5;
	--pce-guide-indent: #9994;
	--pce-ac-icon-class: #ee9d28;
	--pce-ac-icon-enum: #ee9d28;
	--pce-ac-icon-event: #ee9d28;
	--pce-ac-icon-function: #b180d7;
	--pce-ac-icon-interface: #75beff;
	--pce-ac-icon-variable: #75beff;
	--pce-selection: #264f78;
	color-scheme: dark;
}

.match-highlight {
	--pce-bg-highlight: #282828;
}

.pce-match {
	--pce-search-match: #675451;
}

.active-line {
	--pce-line-number: #ccc;
}

.active-indent {
	--pce-guide-indent: #eee6;
}

[class*="language-"],
.token.url {
	color: #9cdcfe;
}

/* Tokens */
.token.namespace {
	opacity: 0.7;
}

.pce-tooltip,
.token.punctuation,
.token.attr-equals,
.token.operator,
.token.combinator,
.token.plain-text {
	color: #d4d4d4;
}

.token.comment,
.token.prolog,
.token.blockquote {
	color: #6a9955;
}

.token.number,
.token.symbol,
.token.inserted,
.token.unit {
	color: #b5cea8;
}

.token.regex,
.language-regex,
.token.regex .punctuation,
.token.group,
.token.string,
.token.string-property.property,
.token.char,
.token.deleted,
.token.attr-value,
.token.attr-value:not(.script):not(.style) > .punctuation,
.token.color {
	color: #ce9178;
}

.token.doctype,
.token.operator.arrow,
.token.keyword,
.token.important,
.token.boolean,
.token.tag,
.token.entity,
.token.regex-flags {
	color: #569cd6;
}

.token.atrule .token.rule {
	color: #c586c0;
}

.token.function,
.token.alternation {
	color: #dcdcaa;
}

.token.italic {
	font-style: italic;
}

.token.class-name,
.token.builtin,
.token.maybe-class-name {
	color: #4ec9b0;
}

.token.doctype .name,
.token.atrule,
.token.atrule .url,
.token.property,
.token.variable,
.token.parameter,
.token.interpolation,
.token.attr-name {
	color: #9cdcfe;
}

.token.selector,
.token.escape {
	color: #d7ba7d;
}

.token.tag > .punctuation,
.token.doctype > .punctuation,
.token.cdata {
	color: #808080;
}

.token.namespace {
	color: #4ec9b0;
}

.token.constant {
	color: #4fc1ff;
}

/* Language overrides */

.token.char-set,
.token.regex .operator {
	color: #d16969;
}

.token.important.title .punctuation,
.token.list,
.token.bold * {
	color: #569cd6;
}

.language-markup,
.language-markdown,
.language-md,
.language-html,
.language-xml,
.language-svg,
.language-text,
.language-vue,
.language-svelte,
.language-astro,
.language-css,
.language-sass,
.language-scss,
.token.code.keyword,
.language-markdown .token.url {
	color: #d4d4d4;
}

.token.token.url > .content,
.token.code.code-snippet,
.token.url-reference .variable {
	color: #ce9178;
}

.token.quantifier {
	color: #d7ba7d;
}

/* Key words */

.token.block > .keyword,
.token.keyword.module,
.token.keyword.control-flow,
.token.keyword-if,
.token.keyword-else,
.token.keyword-return,
.token.keyword-switch,
.token.keyword-case,
.token.keyword-default,
.token.keyword-import,
.token.keyword-from,
.token.keyword-export,
.token.keyword-as,
.token.keyword-for,
.token.keyword-while,
.token.keyword-break,
.token.keyword-continue,
.token.keyword-try,
.token.keyword-catch,
.token.keyword-finally,
.token.keyword-throw,
.token.keyword-yield,
.token.keyword-await {
	color: #c586c0;
}

/* Brackets */

.token.bracket-level-0,
.token.bracket-level-3,
.token.bracket-level-6,
.token.bracket-level-9 {
	color: #ffd700;
}

.token.bracket-level-1,
.token.bracket-level-4,
.token.bracket-level-7,
.token.bracket-level-10 {
	color: #da70d6;
}

.token.bracket-level-2,
.token.bracket-level-5,
.token.bracket-level-8,
.token.bracket-level-11 {
	color: #179fff;
}

.token.interpolation-punctuation {
	color: #569cd6;
}

.token.bracket-error {
	color: #ff1212cc;
}

.token.markup-bracket {
	color: inherit;
}

.active-bracket {
	box-shadow: inset 0 0 0 1px #888, inset 0 0 0 9in #0064001a;
}

.active-tagname,
.word-matches span {
	background: #575757b8;
}
